import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "../auth/_guards/auth.guard";
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes: Routes = [
    {
        "path": "",
        "component": ThemeComponent,
        "canActivate": [AuthGuard],
        "children": [

            // add our routes from here
            // /pages/default/user-management/manage-users/manage-users.module

            {
                "path": "master\/manage-users",
                "loadChildren": ".\/pages\/default\/user-management\/manage-users\/manage-users.module#ManageUsersModule"
            },

            {
                "path": "master\/manage-app",
                "loadChildren": ".\/pages\/default\/master-management\/manage-app\/manage-app.module#ManageAppModule"
            },

            

            {
                "path": "master\/manage-master-contest",
                "loadChildren": ".\/pages\/default\/master-management\/manage-master-contest\/manage-master-contest.module#ManageMasterContestModule"
            },
            {
                "path": "master\/manage-master-zone",
                "loadChildren": ".\/pages\/default\/master-management\/manage-master-zone\/manage-master-zone.module#ManageMasterZoneModule"
            },

            {
                "path": "master\/manage-contest",
                "loadChildren": ".\/pages\/default\/master-management\/manage-contest\/manage-contest.module#ManageContestModule"
            },

         

            {
                "path": "master\/player",
                "loadChildren": ".\/pages\/default\/master-management\/manage-player\/manage-player.module#ManagePlayerModule"
            },

            // portalmanagement start here
            {
                "path": "portalmanagement\/manage-service",
                "loadChildren": ".\/pages\/default\/portal-management\/manage-service\/manage-service.module#ManageServiceModule"
            },

            {
                "path": "portalmanagement\/manage-banner",
                "loadChildren": ".\/pages\/default\/portal-management\/manage-banner\/manage-banner.module#ManageBannerModule"
            },

            {
                "path": "portalmanagement\/manage-publish-banner",
                "loadChildren": ".\/pages\/default\/portal-management\/manage-publish-banner\/manage-publish-banner.module#ManagePublishBannerModule"
            },

            {
                "path": "portalmanagement\/manage-template",
                "loadChildren": ".\/pages\/default\/portal-management\/manage-template\/manage-template.module#ManageTemplateModule"
            },

            {
                "path": "portalmanagement\/manage-portal",
                "loadChildren": ".\/pages\/default\/portal-management\/manage-portal\/manage-portal.module#ManagePortalModule"
            },

            {
                "path": "portalmanagement\/publish-category",
                "loadChildren": ".\/pages\/default\/portal-management\/publish-category\/publish-category.module#PublishCategoryModule"
            },



            // our routes end here

            {
                "path": "reports",
                "loadChildren": ".\/pages\/default\/reports\/reports.module#ReportsModule"
            },

            {
                "path": "index",
                "loadChildren": ".\/pages\/default\/index\/index.module#IndexModule"
            },
        ]
    },
    {
        "path": "snippets\/pages\/user\/login-1",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/user\/user-login-1\/user-login-1.module#UserLogin1Module"
    },
    {
        "path": "snippets\/pages\/user\/login-2",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/user\/user-login-2\/user-login-2.module#UserLogin2Module"
    },
    {
        "path": "snippets\/pages\/user\/login-3",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/user\/user-login-3\/user-login-3.module#UserLogin3Module"
    },
    {
        "path": "snippets\/pages\/user\/login-4",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/user\/user-login-4\/user-login-4.module#UserLogin4Module"
    },
    {
        "path": "snippets\/pages\/user\/login-5",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/user\/user-login-5\/user-login-5.module#UserLogin5Module"
    },
    {
        "path": "snippets\/pages\/user\/login-6",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/user\/user-login-6\/user-login-6.module#UserLogin6Module"
    },
    {
        "path": "snippets\/pages\/errors\/error-1",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/errors\/errors-error-1\/errors-error-1.module#ErrorsError1Module"
    },
    {
        "path": "snippets\/pages\/errors\/error-2",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/errors\/errors-error-2\/errors-error-2.module#ErrorsError2Module"
    },
    {
        "path": "snippets\/pages\/errors\/error-3",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/errors\/errors-error-3\/errors-error-3.module#ErrorsError3Module"
    },
    {
        "path": "snippets\/pages\/errors\/error-4",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/errors\/errors-error-4\/errors-error-4.module#ErrorsError4Module"
    },
    {
        "path": "snippets\/pages\/errors\/error-5",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/errors\/errors-error-5\/errors-error-5.module#ErrorsError5Module"
    },
    {
        "path": "snippets\/pages\/errors\/error-6",
        "loadChildren": ".\/pages\/self-layout-blank\/snippets\/pages\/errors\/errors-error-6\/errors-error-6.module#ErrorsError6Module"
    },
    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
})
export class ThemeRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts